import { render, staticRenderFns } from "./main_btn.vue?vue&type=template&id=a6303962&"
import script from "./main_btn.vue?vue&type=script&lang=js&"
export * from "./main_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports